// Category Repository - Repository Pattern
import apiService from '../api.service';

class CategoryRepository {
  // Get all categories
  async getAll() {
    return apiService.get('/categories');
  }

  // Get single category
  async getById(id) {
    return apiService.get(`/categories/${id}`);
  }

  // Create category
  async create(data) {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (key === 'image' && data[key]) {
        formData.append('image', data[key]);
      } else if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
        formData.append(key, data[key]);
      }
    });
    
    return apiService.post('/categories', formData);
  }

  // Update category
  async update(id, data) {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (key === 'image' && data[key]) {
        formData.append('image', data[key]);
      } else if (data[key] !== null && data[key] !== undefined) {
        const value = data[key] === '' ? '' : String(data[key]);
        formData.append(key, value);
      }
    });
    
    formData.append('_method', 'PATCH');
    
    const url = `${apiService.baseURL}/categories/${id}`;
    const token = localStorage.getItem('adminToken');
    
    const config = {
      method: 'POST',
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: formData,
    };
    
    try {
      const response = await fetch(url, config);
      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'An error occurred' }));
        throw new Error(error.message || `HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('API Request Error:', error);
      throw error;
    }
  }

  // Delete category
  async delete(id) {
    return apiService.delete(`/categories/${id}`);
  }
}

export default new CategoryRepository();
